import { ApiPropertyOptional } from '@nestjs/swagger'
import { IsOptional, IsUUID, IsString } from 'class-validator'
import { OffsetPaginationQueryDto } from '@sphere/shared/domain'

/**
 * DTO for subject list filters
 */
/**
 * DTO for subject list filters
 */
export class SubjectFilterDto extends OffsetPaginationQueryDto {
  @ApiPropertyOptional({
    type: 'string',
    description: 'Search string (code or label)',
    example: 'MATH',
  })
  @IsOptional()
  @IsString()
  search?: string

  @ApiPropertyOptional({
    type: 'string',
    description: 'Filter by subject type UUID',
    example: '123e4567-e89b-12d3-a456-426614174000',
  })
  @IsOptional()
  @IsUUID()
  subjectTypeId?: string

  // Keep typeId for backward compatibility if needed, or remove if unused
  @IsOptional()
  @IsUUID()
  typeId?: string
}

export class ListSubjectsQueryDto
  extends SubjectFilterDto
  implements OffsetPaginationQueryDto {}
